



















































import { Vue, Component, Prop } from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import { ProfileWizardSteps } from "@/employer/types";
import Widget from "@/shared/components/Widget.vue";
import moment from "moment";
import Button from "@/shared/components/ui/Button.vue";
import YearEdit from "./YearEdit.vue";
import PayrollEditSummaryModal from "@/employer/components/payrollcalendar/PayrollEditSummaryModal.vue";
import { useProfileStore } from "@/employer/store/profile";
import { usePayrollCalendarStore } from "@/employer/store/payrollCalendar";

@Component({
  components: {
    Widget,
    Button,
    YearEdit,
    PayrollEditSummaryModal
  }
})
export default class PayrollOnboardingEdit extends Vue {
  profileStore = useProfileStore();
  payrollCalendarStore = usePayrollCalendarStore();

  @Prop({required: true})
  forEmployerId: number;

  @Prop()
  edit: boolean;

  isSubmitting = false;
  userSelectedYear = 0;
  showValidation = false;

  get isLoaded () {
    return this.profileStore.payrollInformationState === FetchState.Loaded;
  }

  get selectedYear () {
    return this.userSelectedYear || this.firstYear;
  }

  get firstYear () {
    return moment(this.profileStore.payrollInformation.firstDateOfYear).year();
  }

  get secondYear () {
    return this.firstYear + 1;
  }

  get employerId () {
    return this.forEmployerId;
  }

  created () {
    this.profileStore.getPayrollInformation(this.employerId);
  }

  get submitDisabled () {
    return this.isSubmitting;
  }

  // notifies the wizard component that it's time to move to the next step
  onComplete () {
    this.$emit("complete");
  }

  onValidate () {
    this.showValidation = true;
    this.payrollCalendarStore.validateAllPayrollDates();
  }

  onCancelValidation () {
    this.showValidation = false;
  }

  onSubmit (): void {
     if (this.isSubmitting) {
      return;
    }
    const employerId = this.employerId;
    this.isSubmitting = true;
    this.showValidation = false;

    this.payrollCalendarStore.saveAllPayrollDates(this.edit)
      .then(() => this.profileStore.saveOnboardProgressComplete({ employerId, onboardingStep: ProfileWizardSteps.PayrollSetup}))
      .then(() => this.profileStore.setWizardComplete(employerId))
      .then(() => this.onComplete())
      .finally(() => this.isSubmitting = false);
  }
}
